import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=2a51c984&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=2a51c984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51c984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a51c984')) {
      api.createRecord('2a51c984', component.options)
    } else {
      api.reload('2a51c984', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=2a51c984&scoped=true&", function () {
      api.rerender('2a51c984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Edit.vue"
export default component.exports